import { render, staticRenderFns } from "./GlobalOfferMain.smartlinks.vue?vue&type=template&id=07227851&scoped=true&"
import script from "./GlobalOfferMain.smartlinks.vue?vue&type=script&lang=js&"
export * from "./GlobalOfferMain.smartlinks.vue?vue&type=script&lang=js&"
import style0 from "./GlobalOfferMain.smartlinks.vue?vue&type=style&index=0&id=07227851&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07227851",
  null
  
)

export default component.exports